'use strict';

angular.module('app').directive('horizontalScroll', function($window, $timeout) {
    var link = function(scope, element) {
        $timeout(function() {
            $(element).slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                fade: false,
                infinite: false,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
        }, 350);
    };
    return {
        restrict: 'A',
        scope: {
            list: '='
        },
        link: link
    };
})